import { Flex, HStack } from '@chakra-ui/react'
import ArrowRightOmens from 'components/svg/ArrowRightOmens'
import { H4 } from 'components/typography'
import Link from 'next/link'
import { FC } from 'react'
import { useDeferMedia } from 'utils/ssrContent'

interface SlideCardProps {
  title?: string
  href: string
  imageSrc: string
}

export const SlideCard: FC<SlideCardProps> = ({ title, href, imageSrc }) => {
  // Not in a lazy section's server HTML (it would download at once); set when the section renders
  const deferMedia = useDeferMedia()
  return (
    <Link prefetch={false} {...{ href }} passHref>
      <Flex
        position="relative"
        backgroundImage={deferMedia ? undefined : imageSrc}
        backgroundPosition="center"
        backgroundSize="cover"
        h={{ base: '320px', lg: '520px' }}
        borderRadius={{ base: '24px', lg: '40x' }}
        overflow="hidden"
      >
        <Flex
          pos="absolute"
          opacity={{ base: '1', lg: '0' }}
          h="full"
          _hover={{
            background: 'rgba(246, 244, 232, 0.1)',
            opacity: '1',
            backdropFilter: 'blur(20px)',
            transition: '0.1s'
          }}
        >
          <HStack w="full" p={{ base: '24px', lg: 8 }}>
            <H4 color="alabaster" mt="auto" pr="0">
              {title}
            </H4>
            <ArrowRightOmens alignSelf="end" fill="alabaster" boxSize="24px" />
          </HStack>
        </Flex>
      </Flex>
    </Link>
  )
}
